import { Icon } from '@/components/wm';
import * as React from 'react';

const ContentHeader = ({ icon, title, children = null }) => {
    return (
        <div className="tw-flex tw-justify-between tw-items-center tw-px-1 tw-py-2 tw-mb-2">
            <div className="tw-flex tw-items-center tw-gap-2">
                {icon && <Icon icon={icon}/>}
                <h2 className="tw-text-secondary !tw-m-0">{title}</h2>
            </div>

            {children && (
                <div className="tw-flex tw-items-center tw-ml-auto">
                    {children}
                </div>
            )}
        </div>
    );
};

export { ContentHeader };
